import React, {useState, useEffect,useRef } from "react";
import "./style.css";
import { Accordion, Modal, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import {useDispatch, useSelector } from "react-redux";
import { RangeWrapper } from "./components/RangeRaper";
import { CheckboxField } from "../Fields/CheckboxField";
import { toggleElementInArray,toggleClassicElementInArray,formatCurrency, formatCurrencyStipend } from "../../helper";
import FilterComponent from "./mobile-filter-modal";
import data from "./data"
import back from "../../Assets/images/back.svg"
import { fetchSearch } from "../../Redux/Actions/ProfileSteps";
import { useDebouncedSearchDispatch } from "../../helper/UseDebouncedSearchDispatch";
import { RESET_SEARCH } from "../../Redux/Actions/types";
import { useSearchParams } from "react-router-dom";
export const FilterBox = ({ handleFilterChange, applyFilter,prefillData, handleResetFilter,type }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams()
  const locationFilter = useSelector(s => s.ProfileSteps.searchByField.locationFilter);
  const companyFilter = useSelector(s => s.ProfileSteps.searchByField.companyFilter);
  const localFilter = useSelector(s => s.jobBoard.localFilter);
      const [locationSearch, setLocationSearch] = useState('');
      const [tabType,setTabType] = useState('')
      const [companySearch, setCompanySearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [searchItem ,setSearchItem] = useState('')
  const filterList = data
  const filterData=data
  const locationRef = useRef(null);
  const companyRef = useRef(null);
    useEffect(() => {
      if (searchParams.has('internship')) {
        setTabType("internship")
      } else if (searchParams.has('fulltime')) {
        setTabType("fulltime")
      } else {
        setTabType("fulltime")
      }
    }, [searchParams]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (locationRef.current && 
          !locationRef.current.contains(event.target) && 
          locationFilter?.length > 0) {
        setLocationSearch('');
        dispatch({ type: RESET_SEARCH });
      }
      
      if (companyRef.current && 
          !companyRef.current.contains(event.target) && 
          companyFilter?.length > 0) {
        setCompanySearch('');
        dispatch({ type: RESET_SEARCH });
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dispatch, locationFilter, companyFilter]);
    const handleLocationSearch = (e) => {
      setSearchItem(e.target.ariaLabel)
      setLocationSearch(e.target.value)
    }
    const handleCompanySearch = (e) => {
      setSearchItem(e.target.ariaLabel)
      setCompanySearch(e.target.value)
    }
useDebouncedSearchDispatch({
  value: locationSearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "homeCity",
  context: "locationFilter",
});
useDebouncedSearchDispatch({
  value: companySearch,
  dispatch,
  fetchAction: fetchSearch,
  search_type: "companyName",
  context: "companyFilter",
});
  const handleClassicCheckBoxChange = (key, value) => {
    if (localFilter.hasOwnProperty(key)) {
      const newData = toggleClassicElementInArray(localFilter?.[key], value);
      handleFilterChange({ [key]: [...newData] })
    } else {
      handleFilterChange({ [key]: [value] })
    }
  }


    const handleCheckBoxChange = (key, value) => {
    const newData = toggleElementInArray(localFilter?.[key], value);
      handleFilterChange({ [key]: newData });
    
  };

  const handleSliderChange = (key, value) => {
    const [minimum, maximum] = value;
    handleFilterChange({ [key]: { minimum, maximum } })
  }

  const handleRadioChange = (key, value) => {
    handleFilterChange({ [key]: [value.object_name] })
  }
    const initialFetch = async(type, context,label) => {
      try {
        setSearchItem(label)
        await dispatch({ type: RESET_SEARCH})
              await dispatch(
                fetchSearch({
                  search_type: type,
                  search_char: "prominentdef",
                  context: context,
                })
              );
            } catch (err) {
              console.error(" search failed:", err);
            }
    }
  return (
    <>
      <div className="job-post-filter">
        <div className="d-flex justify-content-between mb-4 justify-content-end">
          <button type="button" onClick={applyFilter} className={"default-btn blue-bg border-0 py-2 px-3"}>Apply Filter</button>
          <button onClick={handleResetFilter} type="button" className="inter clear-all fs-6">Clear filters</button>
        </div>
        <Accordion className="pe-lg-3" defaultActiveKey={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"]} alwaysOpen>
     {tabType === "internship" &&
  <Accordion.Item eventKey="0">
    <Accordion.Header>Job Type</Accordion.Header>
    <Accordion.Body>
      {[
  { label: "Internship 2 months", value: "INTERNSHIPTWOMONTHS" },
  { label: "Internship 6 months", value: "INTERNSHIPSIXMONTHS" }
].map((item, idx) => {
  const isChecked = localFilter?.job_types?.some(
    (selectedItem) => selectedItem === item.value
  );
  return (
    <CheckboxField
      key={idx}
      onChange={val => handleClassicCheckBoxChange('job_types', item.value)}  
      checked={isChecked} 
      value={item.value}
      id={item.value} 
      label={item.label} 
    />
  );
})}

    </Accordion.Body>
  </Accordion.Item>
}
          {
            <Accordion.Item eventKey="3">
              <Accordion.Header>Location</Accordion.Header>
              <Accordion.Body>
                {
                <form>
                  <div class="input-group">
                    <input type="text" class="form-control search-box bg-white mb-3" onFocus={()=> initialFetch("homeCity","locationFilter","locationFilter")} value={searchItem == "locationFilter" ? locationSearch : ""} onChange={(e) => handleLocationSearch(e)} placeholder="Search" aria-label="locationFilter" aria-describedby="Search by name" />
                  </div>
                </form>}

 {( searchItem == "locationFilter") ? (
                          locationFilter.map((location, index) => {
                          const isChecked = localFilter?.job_locations?.some(
                              (selectedItem) => selectedItem === location.object_name
                          );
                          return (
                              <label key={location.object_id || index} className="checkbox-container form-checkbox mb-3">
                              <input 
                                  type="checkbox" 
                                  className="form-check-input" 
                                  value={location.object_name}
                                  checked={isChecked}
                                  onChange={() => handleRadioChange('job_locations', location)}
                              />
                              <span className="checkboxmark form-check-label">{location.object_name}</span>
                              </label>
                          );
                          })

                      ) : (
                      localFilter?.job_locations?.map((item, idx) => {
                        const isChecked = localFilter?.job_locations?.some(
                          (selectedItem) => selectedItem
                        );
                        
                        return (
                          <CheckboxField 
                            onChange={val => handleRadioChange('job_locations', item)} 
                            key={item} 
                            checked={isChecked}
                            id={item}
                            label={item} 
                          />
                        );
                      }))}
              </Accordion.Body>
            </Accordion.Item>
          }

  {tabType=="fulltime" ?
    <Accordion.Item eventKey="4">
      <Accordion.Header>Salary</Accordion.Header>
      <Accordion.Body className="acc_age">
        <RangeWrapper
  min={600000}
  max={10000000}
  minValue={formatCurrency(localFilter?.pay_scale?.minimum || 600000)}
  maxValue={formatCurrency(localFilter?.pay_scale?.maximum || 10000000)}
  value={[
    localFilter?.pay_scale?.minimum || 600000, 
    localFilter?.pay_scale?.maximum || 10000000
  ]}
  onChange={(value) => {
    const roundedValue = value.map(v => Math.round(v / 100000) * 100000);
    handleSliderChange("pay_scale", roundedValue);
  }}
  startingType=""
  endingType=""
  startingPlaceholder={formatCurrency(localFilter?.pay_scale?.minimum || 600000)}
  endingPlaceholder={formatCurrency(localFilter?.pay_scale?.maximum || 10000000)}
  minStep={100000}
/>
      </Accordion.Body>
    </Accordion.Item> :
    <Accordion.Item eventKey="4">
      <Accordion.Header>Stipend</Accordion.Header>
      <Accordion.Body className="acc_age">
       <RangeWrapper
  min={0}
  max={100000}
  minValue={formatCurrencyStipend(localFilter?.pay_scale?.minimum || 0)}
  maxValue={formatCurrencyStipend(localFilter?.pay_scale?.maximum || 100000)}
  value={[
    localFilter?.pay_scale?.minimum || 0, 
    localFilter?.pay_scale?.maximum || 100000
  ]}
    onChange={(value) => {
    const roundedValue = value.map(v => Math.round(v / 1000) * 1000);
    handleSliderChange("pay_scale", roundedValue);
  }}
  startingType=""
  endingType=""
  startingPlaceholder={formatCurrencyStipend(localFilter?.pay_scale?.minimum || 0)}
  endingPlaceholder={formatCurrencyStipend(localFilter?.pay_scale?.maximum || 100000)}
  minStep={1000}
/>
      </Accordion.Body>
    </Accordion.Item>}

              {(prefillData || filterList?.jobIdDetails) &&
            <Accordion.Item eventKey="3">
              <Accordion.Header>Company Name</Accordion.Header>
              <Accordion.Body>
                {filterList?.jobIdDetails?.allow_search == true &&
                <form>
                  <div class="input-group">
                    <input type="text" class="form-control search-box bg-white mb-3" onFocus={()=> initialFetch("companyName","companyFilter","companyFilter")} value={searchItem == "companyFilter" ? companySearch : ""} onChange={(e) => handleCompanySearch(e)} placeholder="Search" aria-label="companyFilter" aria-describedby="Search by name" />
                  </div>
                </form>}
 {( searchItem == "companyFilter") ? (
                          companyFilter.map((location, index) => {
                          const isChecked = localFilter?.company_list?.some(
                              (selectedItem) => selectedItem.object_id === location.object_id
                          );
                          return (
                              <label key={location.object_id || index} className="checkbox-container form-checkbox mb-3">
                              <input 
                                  type="checkbox" 
                                  className="form-check-input" 
                                  value={location.object_name}
                                  checked={isChecked}
                                  onChange={() => handleCheckBoxChange('company_list', location)}
                              />
                              <span className="checkboxmark form-check-label">{location.object_name}</span>
                              </label>
                          );
                          })

                      ) : (
                      localFilter?.company_list?.map((item, idx) => {
                        const isChecked = localFilter?.company_list?.some(
                          (selectedItem) => selectedItem.object_id === item.object_id
                        );
                        
                        return (
                          <CheckboxField 
                            onChange={val => handleCheckBoxChange('company_list', item)} 
                            key={item.object_id} 
                            checked={isChecked}
                            id={item.object_id}
                            label={item.object_name} 
                          />
                        );
                      }))}
              </Accordion.Body>
            </Accordion.Item>
          }

        </Accordion>
      </div>
    </>
  );
};

export const MobileFilterModal = ({ onClose, onShow, handleFilterChange, applyFilter, handleFilterReset,type }) => {
  const [searchParams] = useSearchParams()
      const [tabType,setTabType] = useState('')

  const submitFilter = () => {
    onClose();
    applyFilter();
  }
      useEffect(() => {
      if (searchParams.has('internship')) {
        setTabType("internship")
      } else if (searchParams.has('fulltime')) {
        setTabType("fulltime")
      } else {
        setTabType("fulltime")
      }
    }, [searchParams]);
  return (
    <>
      <div className="d-block d-lg-none">
        <Modal
          show={onShow}
          onHide={onClose}
          fullscreen
          className="filter-mobile-modal d-block d-lg-none p-0 "
        >
          <Modal.Header className="d-flex justify-content-between w-full filter-header">
            <div className="filter-back-wrapper inter">
              <span onClick={onClose} type="button" className="d-inline-block me-2">
                <img
                  src={back}
                  alt="arrows"
                  className="cursor-pointer me-2"
                />
              </span>
              Filters 
            </div>
            <span className="filter-clear-wrapper inter" type="button" onClick={handleFilterReset}>Clear filters</span>
          </Modal.Header>
          <FilterComponent handleFilterChange={handleFilterChange} type={tabType} submitFilter={submitFilter} />
        </Modal>
      </div>
    </>
  );
};